import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormScriptTypes } from "~/models/Commons ";
import { useSaveScriptTypesMutation } from "~/services/script";


export const useFormScriptType = (
  editedItem: FormScriptTypes | null,
  onCloseModal: () => void,
  refetch: () => void,
  onSuccess?: (title: string, message: string, response: any) => void,
  onError?: (title: string, message: string) => void,
) => {
  const { t } = useTranslation();
  const [saveScriptTypes, { isLoading, isError }] =
    useSaveScriptTypesMutation();

  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm<FormScriptTypes>({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      name: editedItem?.name ?? "",
      description: editedItem?.description ?? "",
      active: editedItem?.active ?? true,
    },
  });

const submitForm = useCallback(
  async (data: FormScriptTypes) => {
    if (isLoading) {
      return;
    }

    try {
      const payload = {
        ...data,
        name: data.name.toUpperCase(),
      };

      const response = await saveScriptTypes({ data: payload }).unwrap();

      refetch();

      onSuccess?.(
        t("MessageOperationCompletedSuceesuflly"),
        response.message,
        response,
      );

      onCloseModal();
    } catch (error: any) {
      onError?.(
        `(${error?.data?.status ?? t("Error")})`,
        error?.data?.detail ?? error?.data?.message ?? t("UnexpectedError"),
      );
    }
  },
  [
    isLoading,
    saveScriptTypes,
    refetch,
    onSuccess,
    onError,
    onCloseModal,
  ],
);

  return {
    handleSubmit,
    submitForm,
    control,
    errors,
    isLoading,
    isError,
  };
};